import { RouteStep } from '~/routes/calculations/types';

const step: RouteStep = {
  route: '/homeowners-insurance/quotes/reminder',
  isAccessible: () => true,
  breadcrumbStep: 'done',
};

export default step;
